import { render, staticRenderFns } from "./Items.vue?vue&type=template&id=24034774&scoped=true&"
import script from "./Items.vue?vue&type=script&lang=ts&"
export * from "./Items.vue?vue&type=script&lang=ts&"
import style0 from "./Items.vue?vue&type=style&index=0&id=24034774&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24034774",
  null
  
)

export default component.exports